
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { singularityStore } from "@/store/store";
import SectionAddOrSwapPanel from "./SectionAddOrSwap/SectionAddOrSwapPanel.vue";
import SectionWriter from "./SectionWriter/SectionWriter.vue";
import AIJobManager from "./AIJobManager/AIJobManager.vue";
import PageStructure from "./PageStructure/PageStructure.vue";
import ImageEditor from "./ImageEditor/ImageEditor.vue";
import BackgroundImageEditor from "./BackgroundImageEditor/BackgroundImageEditor.vue";
import IconEditor from "./IconEditor/IconEditor.vue";
import TextEditor from "./TextEditor/TextEditor.vue";
import LinkEditor from "./LinkEditor/LinkEditor.vue";
import ContentPropertiesEditor from "./ContentPropertiesEditor/ContentPropertiesEditor.vue";

@Component({
  components: {
    SectionAddOrSwapPanel,
    SectionWriter,
    AIJobManager,
    PageStructure,
    ImageEditor,
    BackgroundImageEditor,
    IconEditor,
    TextEditor,
    LinkEditor,
    ContentPropertiesEditor
  }
})
export default class SingularityLeftPanel extends Vue {
  get singularityLeftPanelState() {
    return singularityStore.singularityUiState.singularityLeftPanel;
  }

  get imageEditorKey() {
    return singularityStore.imageEditorPanelState?.imageId || 'no-image';
  }
}
